import { forwardRef } from 'react'
import { Box, Skeleton, Typography, useMediaQuery } from '@mui/material'
import { isPast, isToday } from 'date-fns'
import CalendarEvent from './calendarEvent'
import { useTheme } from '@emotion/react'

const DayDiv = forwardRef(
  (
    {
      day,
      calendarEvent,
      filters,
      index,
      setDrawerData,
      drawerState,
      setDrawerState,
      setTabState,
      isLoading,
    },
    ref
  ) => {
    const handleClickDiv = () => {
      setDrawerState({ ...drawerState, right: true })
      setDrawerData(day.object)
    }

    // Generate a random number between 0 and 3
    const randomSkeletonCount = Math.floor(Math.random() * 4)

    function checkIsPast(date) {
      return isPast(date) && !isToday(date)
    }

    const theme = useTheme()
    const mobile_l = useMediaQuery(theme.breakpoints.up('mobile_l'))

    return (
      <Box
        ref={(el) => (ref.current[index] = el)}
        sx={{
          width: 'calc(100% / 7)',
          boxSizing: 'border-box',
          display: 'flex',
          flexDirection: 'column',
          height: mobile_l ? '180px' : '140px',
          borderLeft: '1px solid #E5E5E5',
          borderTop: '1px solid #E5E5E5',
          overflowY: 'auto',
        }}
      >
        <Box sx={{ display: 'flex', flexDirection: 'column', p: 1 }}>
          <Typography
            sx={{
              alignSelf: 'flex-end',
              color: isToday(day.object) ? 'white.main' : 'initial',
              bgcolor: isToday(day.object) ? 'alternate.main' : 'initial',
              borderRadius: '50%',
              width: 24,
              height: 24,
              fontWeight: isToday(day.object) ? '600' : null,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: mobile_l ? '12px' : '10px',
            }}
            variant="body2"
          >
            {day.day < 10 ? `0${day.day}` : day.day}
          </Typography>
          {isLoading && (
            <Box
              sx={{
                marginTop: 1,
                display: 'flex',
                flexDirection: 'column',
                gap: 1,
              }}
            >
              {Array.from({ length: randomSkeletonCount }).map((_, index) => (
                <Skeleton
                  key={index}
                  animation="wave"
                  variant="rectangular"
                  width={'100%'}
                  height={20}
                />
              ))}
            </Box>
          )}

          {!isLoading && calendarEvent && (
            <CalendarEvent
              handleClickDiv={handleClickDiv}
              date={calendarEvent[0]}
              data={calendarEvent[1]}
              filters={filters}
              setTabState={setTabState}
              isPast={checkIsPast(day.object)}
            />
          )}
        </Box>
      </Box>
    )
  }
)

export default DayDiv

// no longer in use in this codebase but defined in weeklyCalendar components. May no longer works.
export const WeeklyDayDiv = ({ day, calendarEvent, filters }) => {
  return (
    <Box
      sx={{
        width: 'calc(100% / 7)',
        boxSizing: 'border-box',
        display: 'flex',
        alignItems: 'center',
        backgroundColor: isToday(day.object) ? 'alternate.light' : 'white.main',
        border: '1px solid',
        borderColor: 'alternate.light',
      }}
    >
      {calendarEvent && (
        <CalendarEvent date={calendarEvent[0]} data={calendarEvent[1]} filters={filters} />
      )}
    </Box>
  )
}
